


















import { defineComponent, PropType, SetupContext } from '@vue/composition-api';

import BaseText from '@/base/app/components/atoms/BaseText.vue';

import {
  CourseNameFormValue,
  PropsCourseNameForm,
  useCourseNameForm,
} from './CourseNameFormComposable';

type Props = PropsCourseNameForm;

export default defineComponent({
  name: 'ContentsCourseNameForm',
  components: { BaseText },
  model: { prop: 'value', event: 'submit' },
  props: { value: { type: Object as PropType<CourseNameFormValue>, required: true } },
  emits: ['submit'],
  setup(props: Props, { emit }: SetupContext) {
    return useCourseNameForm(props, emit);
  },
});
